import { getDataExportValueTypes } from 'App/data-export/store/selectors/_utils/getDataExportValueTypes'
import { mapSectionToLabel } from 'App/data-export/store/selectors/_utils/mapSectionToLabel'
import { mapValueGroupToLabel } from 'App/data-export/store/selectors/_utils/mapValueGroupToLabel'
import type { TDataExportValueTypesTimeseriesGroup } from 'App/data-export/types/from-code-gen/TDataExportValueTypesTimeseriesGroup'
import type { TDataExportValueTypesTimeseriesSection } from 'App/data-export/types/from-code-gen/TDataExportValueTypesTimeseriesSection'
import { valueTypeRenderers } from 'App/data-export/valueTypeRenderers/valueTypeRenderers'
import type { TFieldAssetStoreState } from 'stores/fieldAssetStore/fieldAssetStore'
import { getInsectNameFromId } from 'utils/getInsectNameFromId'

export const getValueTypesForFieldAssetIdsWithPropertyId = (args: {
  propertyId: string | null
  lngLats: string[]
  blockIds: string[]
  irrigationZoneEmitterIds: string[]
  fieldAssetStoreState: TFieldAssetStoreState
}) => {
  const valueTypesForProperty =
    args.propertyId !== null
      ? getDataExportValueTypes({
          propertyId: Number(args.propertyId),
          fieldAssetStoreState: args.fieldAssetStoreState,
        })
      : []

  const valueTypesForSelectedFieldAssets = valueTypesForProperty
    .filter((x) => {
      if (x.fieldAssetType === 'points' && args.lngLats.includes(x.fieldAssetId)) {
        return true
      }

      if (x.fieldAssetType === 'blocks' && args.blockIds.includes(x.fieldAssetId)) {
        return true
      }

      if (x.fieldAssetType === 'irrigation_zones' && args.irrigationZoneEmitterIds.includes(x.fieldAssetId)) {
        return true
      }

      return false
    })
    .map((item) => {
      const valueType = item.valueType as keyof typeof valueTypeRenderers
      const insectId = item.section === 'pests' ? item.valueType.split('_').slice(-1)[0] : null
      const insectLabel = insectId === null ? null : getInsectNameFromId(Number(insectId))
      const valueTypeLabel = valueTypeRenderers[valueType]?.label(item.valueType)

      return {
        ...item,
        sectionLabel: mapSectionToLabel[item.section as TDataExportValueTypesTimeseriesSection](),
        valueGroupLabel: mapValueGroupToLabel[item.valueGroup as TDataExportValueTypesTimeseriesGroup](),
        valueTypeLabel: valueTypeLabel ?? item.valueType,
        insectId,
        insectLabel,
      }
    })

  return valueTypesForSelectedFieldAssets
}
